export default "__VITE_ASSET__440e9189__"